import React, { Component } from 'react';
import Config from './Config';
import FX from './functions/functions';

class Invoicing extends Component {
  constructor(props) {
    super(props);
    console.log(localStorage);
    //this.props.root.state.forceUpdate();
  }
  render() {
      return (
        <div className="Invoicing">
          <br/><br/><br/><br/>
          <div>Invoicing</div>
        </div>
      );
  }
}

export default Invoicing;



// WEBPACK FOOTER //
// ./src/Invoicing.js